import type { FormType, ProductType } from '~/shared/domain/models';

export type ResultError = {
  code: string;
  message: string;
  details: Array<string>;
};

export type ResultSuccess = {
  id: string;
};

export class AcquisitionRequestError extends Error {
  code: ResultError['code'];

  message: ResultError['message'];

  details: ResultError['details'];

  constructor({ message, code, details }: ResultError) {
    super(message);

    this.code = code;
    this.message = message;
    this.details = details;

    Object.setPrototypeOf(this, AcquisitionRequestError.prototype);
  }

  public static fromResult(resultError: ResultError) {
    return new AcquisitionRequestError(resultError);
  }
}

export type FormData = {
  type: FormType;
  product: ProductType;
  attributes: Record<string, any>;
};
